document
  .querySelectorAll(".js-product-form__submit--popup")
  .forEach(function (column) {
    column.addEventListener("click", function () {
      document.querySelector(".js-popup-offer").classList.add("active");
    });
  });

document.querySelectorAll(".js-close-popup-offer").forEach(function (closeBtn) {
  closeBtn.addEventListener("click", function () {
    document.querySelector(".js-popup-offer").classList.remove("active");
  });
});

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape" || event.key === "Esc") {
    document.querySelector(".js-popup-offer").classList.remove("active");
  }
});
document.addEventListener("rebuy:smartcart.show", (event) => {
      document.querySelector(".js-popup-offer").classList.remove("active");
});
